import { useEffect, useRef } from "react";
import despia from "despia-native";
import { useAuth } from "@/hooks/useAuth";
import { isNativeShell } from "@/lib/oauthRedirect";

/**
 * Mounted once at app root. On every authenticated load inside the native
 * shell, registers the user with OneSignal via the Despia bridge.
 */
export function usePushNotifications() {
  const { user } = useAuth();
  const boundForUserRef = useRef<string | null>(null);

  useEffect(() => {
    if (!user) return;
    if (!isNativeShell()) return;
    if (boundForUserRef.current === user.id) return;

    try {
      despia(`setonesignalplayerid://?user_id=${user.id}`);
      boundForUserRef.current = user.id;
      console.log("[push] ✅ set OneSignal user_id to", user.id);
    } catch (e) {
      console.error("[push] setonesignalplayerid failed:", e);
    }
  }, [user]);
}
